{
	"name": "oym",
	"version": "4.2.0",
	"description": "",
	"main": "build/index.js",
	"type": "module",
	"scripts": {
		"dev": "node esbuild.config.js mode=development",
		"build": "node esbuild.config.js mode=production"
	},
	"author": "",
	"license": "ISC",
	"dependencies": {
		"@prismicio/react": "^2.7.4",
		"@tweenjs/tween.js": "^21.0.0",
		"change-case": "^4.1.2",
		"detect-browser": "^5.3.0",
		"gl-matrix": "^3.4.3",
		"js-cookie": "^3.0.5",
		"lethargy": "^1.0.7",
		"prismic-reactjs": "^1.3.4",
		"requestanimationframe-timer": "^3.0.3",
		"sass-easing": "^1.0.3",
		"sass-em": "^2.0.0",
		"shuffle-array": "^1.0.1",
		"three": "^0.155.0",
		"webfontloader": "^1.6.28"
	},
	"devDependencies": {
		"@prismicio/client": "^7.1.0",
		"@types/node": "^20.4.8",
		"@types/prettier": "^3.0.0",
		"@types/react": "^18.2.19",
		"@types/react-dom": "^18.2.7",
		"@types/three": "^0.155.0",
		"@types/webgl2": "^0.0.7",
		"child_process": "^1.0.2",
		"esbuild": "^0.18.20",
		"esbuild-plugin-glslify": "^1.0.1",
		"esbuild-sass-plugin": "^2.10.0",
		"events": "^3.3.0",
		"file-loader": "^6.2.0",
		"fs-extra": "^11.1.1",
		"glob": "^10.3.3",
		"glslify": "^7.0.0",
		"glslify-loader": "^2.0.0",
		"path": "^0.12.7",
		"postcss-loader": "^7.3.3",
		"prettier": "^3.0.1",
		"react": "^18.2.0",
		"react-dom": "^18.2.0",
		"typescript": "^5.1.6"
	}
}
